(function () {
class $f64f47bbc4ae430a$var$LSGSubscriptionPopup extends HTMLElement {
    constructor(){
        super();
        this.pendingKey = 'lsg_sub_popup_pending';
    }
    connectedCallback() {
        this.overlay = this.querySelector('#subscription-popup-overlay');
        this.card = this.querySelector('.subscription-popup__card');
        this.closeBtn = this.querySelector('.subscription-popup__close');
        if (!this.overlay) return;
        this.closeBtn?.addEventListener('click', (e)=>{
            e.preventDefault();
            this.close();
        });
        this.addEventListener('click', (e)=>{
            if (this.card && !this.card.contains(e.target)) this.close();
        });
        this._markHandler = (e)=>{
            const t = e.target;
            const form = t?.closest?.('form') || t?.form || null;
            if (!form) return;
            const isATCButton = t?.matches?.('#AddToCart, [name="add"][type="submit"], button[name="add"]');
            const isCartAddForm = /\/cart\/add/.test(form.action || '');
            if (!isATCButton && !isCartAddForm) return;
            const otp = form.querySelector('input[name="lsg-frequency-selector"][value="otp"]');
            if (otp && otp.checked) sessionStorage.setItem(this.pendingKey, '1');
        };
        document.addEventListener('click', this._markHandler, {
            capture: true
        });
        document.addEventListener('submit', this._markHandler, {
            capture: true
        });
        this._tryOpenFromMarker();
        requestAnimationFrame(()=>this._tryOpenFromMarker());
        this._onCtaClick = ()=>this.close();
        this._ctaLinks = this.querySelectorAll('[data-subpopup-close], .subscription-popup__cta[href]');
        this._ctaLinks.forEach((el)=>el.addEventListener('click', this._onCtaClick, {
                capture: true
            }));
    }
    disconnectedCallback() {
        document.removeEventListener('click', this._markHandler, {
            capture: true
        });
        document.removeEventListener('submit', this._markHandler, {
            capture: true
        });
        if (this._ctaLinks) {
            this._ctaLinks.forEach((el)=>el.removeEventListener('click', this._onCtaClick, {
                    capture: true
                }));
            this._ctaLinks = null;
        }
    }
    onCartPage() {
        return location.pathname.replace(/\/+$/, '') === '/cart';
    }
    isBlocked() {
        return document.cookie.split('; ').some((c)=>c.startsWith('lsg_subscription_popup_session='));
    }
    setBlockCookie() {
        document.cookie = 'lsg_subscription_popup_session=1; Path=/; SameSite=Lax';
    }
    open() {
        if (!this.overlay || this.isBlocked()) return;
        this.overlay.classList.remove('hidden');
        this.overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('no-scroll');
    }
    close() {
        this.setBlockCookie();
        sessionStorage.removeItem(this.pendingKey);
        this.overlay.classList.add('hidden');
        this.overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('no-scroll');
    }
    _tryOpenFromMarker() {
        const pending = sessionStorage.getItem(this.pendingKey) === '1';
        if (pending && this.onCartPage() && !this.isBlocked()) setTimeout(()=>this.open(), 0);
    }
}
if (!customElements.get('lsg-subscription-popup')) customElements.define('lsg-subscription-popup', $f64f47bbc4ae430a$var$LSGSubscriptionPopup);

})();
